import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class WGZeroBetController extends ZeroBetController {
    constructor() {
        super();
    }

    protected calculateIsTriggered(data: ParsedServerData): boolean {
        return data.nextMode === GameMode.FREESPIN;
    };

    protected getZeroBetNumberLeft(data: ParsedServerData): number {
        return data.freespinsLeft;
    }

    public shouldShowZeroBetCounter(): boolean {
        return true;
    }

    public shouldSubtractZeroBetCounter(): boolean {
        return true;
    }
}